import React from 'react';
import { Mui } from '@osu/react-ui';

/**
 * SearchInput Component
 * Handles the search input field, helper text, and clear button
 */
function SearchInput({
  searchQuery,
  showLoadingIndicator,
  onChange,
  onClear,
  disabled = false
}) {
  return (
    <Mui.Box sx={{ mb: 2 }}>
      <Mui.FormControl fullWidth size="medium">
        <label
          htmlFor="student-search-input"
          style={{
            display: 'block',
            marginBottom: '8px',
            fontSize: '14px',
            fontWeight: 500,
            color: '#333'
          }}
        >
          Search by name, email, or student ID
        </label>

        <input
          id="student-search-input"
          type="text"
          value={searchQuery}
          onChange={onChange}
          placeholder="Enter student name, email, or ID..."
          disabled={disabled}
          style={{
            width: '100%',
            padding: '12px 14px',
            border: '1px solid #c4c4c4',
            borderRadius: '4px',
            fontSize: '16px',
            fontFamily: 'inherit',
            boxSizing: 'border-box'
          }}
          aria-describedby="search-helper-text"
        />

        <Mui.FormHelperText
          id="search-helper-text"
          sx={{
            marginLeft: 0,
            marginRight: 0,
            paddingLeft: 0,
            paddingRight: 0
          }}
        >
          {showLoadingIndicator ? 'Searching...' :
            searchQuery.length > 0 && searchQuery.length < 2 ? 'Enter at least 2 characters to search' :
              'Type to search for students (minimum 2 characters)'}
        </Mui.FormHelperText>
      </Mui.FormControl>

      {/* Clear Search Button */}
      {searchQuery && (
        <Mui.Button
          variant="outlined"
          size="small"
          onClick={onClear}
          sx={{ mt: 1 }}
        >
          Clear Search
        </Mui.Button>
      )}
    </Mui.Box>
  );
}

export default SearchInput;